import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=49a593e5"
import script from "./LinkButton.vue?vue&type=script&lang=ts"
export * from "./LinkButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports